import { motion } from 'framer-motion';
import classes from './index.module.scss';
interface IFooterColumnProps {
  index: number;
  data: string[];
}

const FooterColumn = ({ index, data }: IFooterColumnProps) => (
  <motion.div
    initial={{
      x: index % 2 === 0 ? -200 : 200,
      opacity: 0,
    }}
    transition={{ duration: 1 }}
    whileInView={{ opacity: 1, x: 0 }}
    className={classes.wrap}>
    {data.map((item: any, index) => {
      return <div key={index + 'colunm_footer'}>{item.render ? <item.render /> : item.text}</div>;
    })}
  </motion.div>
);

export default FooterColumn;
